






































































import Vue from 'vue';
import Component from 'vue-class-component';
import TitleSmall from '@/components/title/small.vue';
import TextBody from '@/components/text/body.vue';
import TextCaption from '@/components/text/caption.vue';

@Component({
  components: {
    TitleSmall,
    TextBody,
    TextCaption,
  },
  props: ['column', 'smMargin'],
})
export default class ListColumn extends Vue {}
